/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { API } from 'middleware/api';
import { FACEBOOK } from 'middleware/facebook';
import { GOOGLE } from 'middleware/google';

export const FB_AUTH_REQUEST = 'FB_AUTH_REQUEST';
export const FB_AUTH_SUCCESS = 'FB_AUTH_SUCCESS';
export const FB_AUTH_FAILURE = 'FB_AUTH_FAILURE';

/**
 * Create action object that is used to initiate the auth dialog with Facebook.
 *
 * @return {Object}
 */
export const facebookAuth = () => ({
  [FACEBOOK]: {
    type: 'auth',
    types: [FB_AUTH_REQUEST, FB_AUTH_SUCCESS, FB_AUTH_FAILURE],
  },
});

export const G_AUTH_REQUEST = 'G_AUTH_REQUEST';
export const G_AUTH_SUCCESS = 'G_AUTH_SUCCESS';
export const G_AUTH_FAILURE = 'G_AUTH_FAILURE';

/**
 * Create action object that is used to initiate the auth dialog with Google.
 *
 * @return {Object}
 */
export const googleAuth = () => ({
  [GOOGLE]: {
    type: 'auth',
    types: [G_AUTH_REQUEST, G_AUTH_SUCCESS, G_AUTH_FAILURE],
  },
});

export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';

/**
 * Create action object that is used to authenticate with backend.
 *
 * @param {Object} creds - The authenticate model credentials for a user.
 * @param {string} creds.facebook_token - FB access token obtained via the FB Login button.
 * @param {string} creds.facebook_login_id - FB ID of user via login flow.
 * @param {string} creds.linkedin_token - Linkedin access token obtained via the Linkedin Login widget.
 * @param {string} creds.linkedin_login_id - Linkedin’s own user ID for that person.
 * @param {string} creds.google_token - Google access token obtained via the Google Login widget.
 * @param {string} creds.google_login_id - Google’s own user ID for that person.
 * @param {string} creds.language - Preferred language to use when communicating with this user (as an ISO 639-1 code).
 * @param {string} creds.email - The user’s email address, used for signup/login.
 * @param {string} creds.password_hash - MD5 hash of the user’s password.
 * @param {string} creds.as_user - Impersonate this user (admins only).
 * @param {string} creds.invite_id - A unique reference ID binding this signup to another user.
 * @param {('CLIENT'|'TALENT')} creds.signup_as - If user is signing up, whether doing so as a Talent or Client.
 *
 * @return {Object}
 */
export const authenticate = creds => ({
  [API]: {
    endpoint: '/user/authenticate',
    method: 'POST',
    body: creds,
    types: [AUTH_REQUEST, AUTH_SUCCESS, AUTH_FAILURE],
  },
});

export const AUTH_CLEAR = 'AUTH_CLEAR';

/**
 * Action that defines auth delete / logout.
 *
 * @return {Object}
 */
export const logout = () => ({
  type: AUTH_CLEAR,
});
